import { Component, Input } from '@angular/core';
import { RequestRoot } from 'types';
import { PrintFormV2 } from '../request-print-form-v2';
import { IPrintDepartment } from '../../model/print-department';
import { PrintQRCodeGenerationService } from '../../service/print-qrcode-generation.service';

@Component({
    selector: 'adult-request-form-v2',
    templateUrl: './adult-request-form-v2.component.html',
    styleUrls: ['./adult-request-form-v2.component.scss']
})
export class AdultRequestFormV2Component extends PrintFormV2 {
    @Input() model: RequestRoot;
    @Input() department: IPrintDepartment;
    @Input() version: string;

    constructor(qrCodeService: PrintQRCodeGenerationService) {
        super(qrCodeService);
    }
}
